import NumberInterval from './numberInterval';

export default NumberInterval;
